import { ApiRequestError } from "@cfg/api-contract";

export type FriendlyErrorKind = "offline" | "signIn" | "notFound" | "generic";

/**
 * What kind of failure an error is, for a message people can act on instead
 * of the raw exception ("TypeError: Failed to fetch", "Sign in required").
 */
export function errorKind(err: unknown): FriendlyErrorKind {
  if (err instanceof ApiRequestError) {
    if (err.status === 401 || err.status === 403) return "signIn";
    if (err.status === 404) return "notFound";
    return "generic";
  }
  // fetch() rejects with a TypeError when the network or server can't be reached.
  if (err instanceof TypeError || (typeof navigator !== "undefined" && navigator.onLine === false)) return "offline";
  return "generic";
}

/** Copy key of the message for `err`. */
export function errorCopyKey(err: unknown): `error.${FriendlyErrorKind}` {
  return `error.${errorKind(err)}`;
}
